import { ENV } from '@/environment/client';

import { EthereumAddress } from './models';

export type SwapFeeInfo = {
  swapFeeBps: number | undefined;
  swapFeeRecipient: EthereumAddress | undefined;
  swapFeeToken: EthereumAddress | undefined;
};

/**
 * Builds the fee query params for 0x price/quote requests. Swap (integrator)
 * fees are all-or-nothing: bps, recipient, and token are only sent when all
 * three are present. The trade surplus recipient is added only when Matcha
 * runs embedded in an iframe.
 */
export const getFeeRequestParams = ({
  swapFeeBps,
  swapFeeRecipient,
  swapFeeToken,
}: SwapFeeInfo): Record<string, string> => {
  const params: Record<string, string> = {};

  if (swapFeeBps && swapFeeRecipient && swapFeeToken) {
    params.swapFeeBps = swapFeeBps.toString();
    params.swapFeeToken = swapFeeToken;
    params.swapFeeRecipient = swapFeeRecipient;
  }

  if (
    typeof window !== 'undefined' &&
    window.self !== window.top &&
    ENV.NEXT_PUBLIC_TRADE_SURPLUS_RECIPIENT_ADDRESS
  ) {
    params.tradeSurplusRecipient = ENV.NEXT_PUBLIC_TRADE_SURPLUS_RECIPIENT_ADDRESS;
  }

  return params;
};
